import React, { useEffect, useRef, useState } from "react";
import * as image from "../../resources/images";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { PATHS } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import { createUserPin, verifyUserPin } from "../../redux/actions/APIs";
import { getCapitalized, getChildData, getProfileName } from "../../utils/helper";
import { defaultChild } from "../../redux/actions";
import { useForm } from "react-hook-form";
import { Modal, ModalFooter } from "react-bootstrap";
const UserPinPopUp = ({ handleUserPinPopUp, userData }) => {
	const dispatch = useDispatch();
	const {
		verifyPinResponse,
		alluserdetails,
	} = useSelector((state) => state.collections);

	const { handleSubmit, setValue, formState } = useForm({
			mode: "onTouched",
		});

	const inputRef = useRef([]);
	const [getPinValue, setPinValue] = useState(['', '', '', '']);
	const [loader, setLoader] = useState(false);

	useEffect(() => {
		dispatch(verifyUserPin());
		setTimeout(() => {
			inputRef.current[0]?.focus();
		}, 0);
	}, [])

	const handlePin = (value, index) => {
		// Allow only single digit 0–9
		if (/^\d?$/.test(value)) {
			const newValues = [...getPinValue];
			newValues[index] = value;
			setPinValue(newValues);

			// Move focus to next input if filled
			if (value && index < inputRef.current.length - 1) {
				inputRef.current[index + 1].focus();
			}
		}
	}

	const handleKeyDown = (e, index) => {
		if (e.key === 'Backspace' && !getPinValue[index] && index > 0) {
			// Move to previous input on backspace if empty
			inputRef.current[index - 1].focus();
		}
	};

	const subMitPin = () => {
		if (userData?.userType === "LEARNER") {
			let access = localStorage.getItem("access_token");
			let tokenData = access.split("##");
			// console.log("subMitPin : ", tokenData, userData?.id, alluserdetails, getChildData(alluserdetails, userData.id));
			localStorage.setItem("access_token", tokenData[0] + "##" + userData.id,);
			dispatch(defaultChild(getChildData(alluserdetails, userData.id)));
		}
		setLoader(true);
		let getPinStr = getPinValue.join('');
		let body = { pin: getPinStr };
		if (userData?.isPin) {
			dispatch(verifyUserPin(userData?.id, body))
		} else {
			dispatch(createUserPin(userData?.id, body));
		}
	}

	return (
		<div className="smallpopup RootContent ">
			<div className="modal d-flex" id="schoolactivity3" role="dialog">
				<div className="modal-dialog modal-lg">
					<div className="modal-content my_popup">
						<div className="modal-header p-0 pb-2">
							<h2 className="flexone w-100">
								{userData?.isPin ? "Verify Your Pin" : "Create Your Pin"}
								<button className="closebtn" data-dismiss="modal" onClick={() => handleUserPinPopUp(false)}>

									<i class="fa-regular fa-xmark"></i>
								</button>
							</h2>
						</div>
						{/* <div className="modal-body paymentinfo p-0"> */}
						<form onSubmit={handleSubmit(subMitPin)}>
							<Modal.Body>
							<div className="myParent_profile">
								<div className="Abotitems flextwo">
									<div className="items_image mr-3">
										{userData?.imageUrl ? (<img src={userData?.imageUrl} alt="character_image" className="br-50 " />) : (<span class="user_initials mr-3">{getProfileName(userData)}</span>)}
									</div>
									<div className="aboutitemsdtl">
										<h2>{getCapitalized(userData?.firstName)}</h2>
										<p className="">{getCapitalized(userData?.userType)}</p>
									</div>
								</div>
								
									
									<div class="input-group position-relative">
									<label>Pin<span class="mandatoryField">*</span></label>
									<div class="form-group" id="mypingenrater">
										{getPinValue?.map((value, index) => (
											<input
												key={index}
												type="text"
												class="form-control"
												inputMode="numeric"
												pattern="[0-9]*"
												maxLength={1}
												value={value}
												onChange={(e) => handlePin(e.target.value, index)}
												onKeyDown={(e) => handleKeyDown(e, index)}
												ref={(el) => (inputRef.current[index] = el)}
											/>
										))}
									</div>
									<div>
									</div>
									</div>
										{verifyPinResponse?.records?.length === 0 && (
									<div>
										<p className='text-danger'>
											{verifyPinResponse?.message}
										</p>
									</div>
									
								)}
									
								
								
								
							</div>
							</Modal.Body>
							<ModalFooter>
							<div className="text-right">
								{loader && false ? (
									<button
										type='button'
										className='btn-blue btn-login d-block mb-5 '
										disabled={true}>
										<span className='RounAnimation mr-1'></span> Please
										wait...
									</button>
								) : (
									<button
										type="submit"
										className="mybutton flexfive"
										disabled={(getPinValue?.length < 4 || getPinValue?.some((value) => !value))}
										// onClick={() => subMitPin()}
									>
										<i class="fa-regular fa-circle-check mr-1"></i> {userData?.isPin ? "Verify Pin" : "Create Pin"}
									</button>
								)}
							</div>
						</ModalFooter>
						</form>
							
						{/* </div> */}
						
					</div>
				</div>
			</div>
		</div>
	)
}
export default UserPinPopUp;